import { Container } from "@octopus-energy/coral/atoms"
import { type SbBlokMargin } from "../types"

interface DynamicMarginProps {
    blok: SbBlokMargin
}

export default function DynamicMargin({ blok }: DynamicMarginProps) {
    return <Container marginBottom={blok.size} />
}
